import { Asset, ChatIcon, Button } from '@clearcover/atlas';
import React, { FC } from 'react';
import { reportEvent } from 'Shared/analytics';
import { useZendeskControls } from 'Shared/hooks/useZendeskControls/useZendeskControls';
import styles from './styles.module.css';
import { useAdaControls } from 'Shared/hooks/useAdaControls/useAdaControls';
import { env } from 'Shared/constants/env';

export const Helpdesk: FC<{
  appId: string;
  screen: string;
}> = ({ appId, screen }) => {
  const zendesk = useZendeskControls('quoteApp');
  const ada = useAdaControls();
  const isUsingAda = env.adaChatEnabled;
  const isHelpdeskLoaded = isUsingAda ? ada.loaded : zendesk.loaded;

  const handleClick = () => {
    const helpdesk = isUsingAda ? ada : zendesk;
    const eventName = isUsingAda
      ? 'aqui-ada-widget-open'
      : 'aqui-zendesk-widget-open';

    if (!helpdesk.isOpen) {
      reportEvent(eventName, {
        appId,
        screen,
      });
    }
    helpdesk.toggleOpen();
  };

  return isHelpdeskLoaded ? (
    <Button
      data-testid="aqui-helpdesk"
      type="button"
      variant="primary"
      size="sm"
      title="Contact Helpdesk"
      className={styles.helpButton}
      onClick={handleClick}
    >
      <Asset
        icon={ChatIcon}
        height={24}
        width={24}
        description={'Help Icon'}
        className={styles.helpIcon}
      />
      Chat
    </Button>
  ) : null;
};
